import { type FC } from "react";
import { Dialog } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useCreateLinkMutation } from "@/partner/entities/links";
import { linkFormValuesToInput, type LinkFormValues } from "../model";
import { LinkForm } from "./LinkForm";

interface CreateLinkDialogProps {
  open: boolean;
  onClose: () => void;
  onCompleted?: () => void;
}

export const CreateLinkDialog: FC<CreateLinkDialogProps> = ({
  open,
  onClose,
  onCompleted,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [createLink, { loading }] = useCreateLinkMutation({
    refetchQueries: ["LinksList"],
  });

  const handleSubmit = async (values: LinkFormValues) => {
    await createLink({
      variables: {
        input: linkFormValuesToInput(values),
      },
      onCompleted: () => {
        enqueueSnackbar(t("links.create.success"), {
          variant: "success",
        });
        onCompleted?.();
      },
      onError: (error) => {
        enqueueSnackbar(error.message, { variant: "error" });
      },
    });
  };

  return (
    <Dialog fullWidth maxWidth="md" scroll="body" open={open} onClose={onClose}>
      <LinkForm
        onSubmit={handleSubmit}
        onClose={onClose}
        title={t("links.create.title")}
        loading={loading}
      />
    </Dialog>
  );
};
